/**
 * This middleware captures actions and  handle custom events
 */
import { updateTTL } from 'Utility/globalMethods'
import { doGlobalLoading } from 'Store/actions/loading'
import { doPopup } from 'Store/actions/popup'
import { DEFAULT_BANK } from 'Schemas/constants'
import { getBankFromPath } from 'Utility/bankMethods'
import { routesList } from 'Schemas/routesList'

const globals = (store) => (next) => (action) => {
  if (/_FAILURE|_SUCCESS/i.test(action.type)) {
    store.dispatch(doGlobalLoading(false))
    const { error, payload } = action
    const status = payload?.status || payload?.data?.errcode || error?.status

    if ((status === 401 || status === 403) && /_FAILURE/i.test(action.type)) {
      window.sessionStorage.clear()
      window.location = routesList.goToAuthorize(getBankFromPath() || DEFAULT_BANK)
    }

    if (payload?.ignoreSystemError) {
      return next(action)
    }

    if (status >= 400 && status <= 600 && status !== 401 && status !== 403 && /_FAILURE/i.test(action.type)) {
      store.dispatch(doPopup('GENERIC_ERROR'))
    }

    return next(action)
  }

  if (/_REQUEST/i.test(action.type)) {
    updateTTL()
    store.dispatch(doGlobalLoading(true))
  }
  return next(action)
}

export default globals
